export const getCurrencySymbol = (currencyCode = 'USD') => {
  if (!currencyCode) return '$';
  try {
    return (0).toLocaleString(undefined, {
      style: 'currency',
      currency: currencyCode,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).replace(/\d/g, '').trim();
  } catch (e) {
    console.error("Invalid currency code:", currencyCode);
    return '$';
  }
};
  
export const formatCurrency = (amount) => {
  const num = parseFloat(amount);
  if (isNaN(num)) return "0.00";
  return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};